import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Send, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ForwardDialog({ image, onClose }) {
  const [friends, setFriends] = useState(null);
  const [sent, setSent] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/friends").catch(() => ({ data: [] })), api.get("/messages").catch(() => ({ data: [] }))]).then(([fr, cv]) => {
      const list = [...fr.data.map((f) => ({ id: f.id, name: f.name, avatar: f.avatar })), ...cv.data.map((c) => ({ id: c.user_id, name: c.name, avatar: c.avatar }))];
      setFriends(list.filter((x, i) => x.id && list.findIndex((y) => y.id === x.id) === i));
    });
  }, []);
  const send = async (f) => {
    try { await api.post("/messages", { to_user: f.id, body: "", image }); setSent((s) => [...s, f.id]); toast.success(`U dërgua te ${f.name}`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Nuk u dërgua"); }
  };
  return createPortal(
    <div className="fixed inset-0 z-[9998] bg-black/50 flex items-end sm:items-center justify-center p-3" onClick={onClose} data-testid="forward-dialog">
      <div className="bg-white rounded-3xl w-full max-w-sm p-4 max-h-[70vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 mb-3">
          <img src={image} alt="" className="w-12 h-12 rounded-xl object-cover" />
          <div className="flex-1 font-extrabold text-slate-900">Ndaje foton me një shok</div>
          <button onClick={onClose} data-testid="forward-close" className="p-1 text-slate-500"><X className="w-5 h-5" /></button>
        </div>
        <div className="overflow-y-auto space-y-1">
          {friends === null && <p className="text-sm text-slate-400 text-center py-4">Duke ngarkuar...</p>}
          {friends?.length === 0 && <p className="text-sm text-slate-400 text-center py-4">Ende nuk ke shokë apo biseda.</p>}
          {(friends || []).map((f) => (
            <div key={f.id} className="flex items-center gap-3 p-2 rounded-xl hover:bg-slate-50" data-testid={`forward-friend-${f.id}`}>
              <span className="w-9 h-9 rounded-full bg-emerald-100 text-emerald-700 font-bold flex items-center justify-center overflow-hidden">{f.avatar ? <img src={f.avatar} alt="" className="w-full h-full object-cover" /> : f.name?.[0]}</span>
              <span className="flex-1 min-w-0 truncate text-sm font-semibold text-slate-800" translate="no">{f.name}</span>
              {sent.includes(f.id)
                ? <span className="text-xs font-bold text-emerald-600">U dërgua</span>
                : <button data-testid={`forward-send-${f.id}`} onClick={() => send(f)} className="h-8 px-3 rounded-full bg-emerald-500 text-white text-xs font-bold flex items-center gap-1"><Send className="w-3.5 h-3.5" />Dërgo</button>}
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
}
